import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";

import UpcomingBigEvents from "@/components/UpcomingBigEvents";
import Footer from "@/components/Footer";
import YourTeamsSection from "@/components/YourTeamsSection";
import YourPlayersSection from "@/components/YourPlayersSection";
import HomeDemoTeaser from "@/components/HomeDemoTeaser";

// Lazy load below-the-fold components to reduce initial bundle size
const LiveOddsTicker = lazy(() => import("@/components/LiveOddsTicker"));
const LiveGames = lazy(() => import("@/components/LiveGames"));
const BettingSection = lazy(() => import("@/components/BettingSection"));
const Tournaments = lazy(() => import("@/components/Tournaments"));
const StatsSection = lazy(() => import("@/components/StatsSection"));
const PlayerSection = lazy(() => import("@/components/PlayerSection"));
const PlayoffBracket = lazy(() => import("@/components/PlayoffBracket"));

const InternationalTournaments = lazy(() => import("@/components/InternationalTournaments"));
const Standings = lazy(() => import("@/components/Standings"));
const Rulebook = lazy(() => import("@/components/Rulebook"));
const HockeyChatbot = lazy(() => import("@/components/HockeyChatbot").then(m => ({ default: m.HockeyChatbot })));

// Minimal loading placeholder that doesn't cause layout shift
// Uses CSS containment to isolate layout recalculations
// Accepts optional id prop so anchor targets exist immediately for navigation
const SectionFallback = ({ id }: { id?: string }) => (
  <div id={id} className="min-h-[200px]" style={{ contain: 'layout style' }} />
);

const Index = () => {
  return (
    <div className="min-h-screen bg-background pt-16">
      <Navbar />
      <main>
        <HeroSection />
        
        {/* Homepage teaser: Build Your Hub */}
        <HomeDemoTeaser />
        {/* Your Teams Section - Personalized favorites */}
        <YourTeamsSection />
        {/* Your Players Section - Personalized player tracking */}
        <YourPlayersSection />
        <Suspense fallback={<SectionFallback />}>
          <LiveOddsTicker />
        </Suspense>
        <Suspense fallback={<SectionFallback id="live-games" />}>
          <LiveGames />
        </Suspense>
        <UpcomingBigEvents />
        <Suspense fallback={<SectionFallback id="tournaments" />}>
          <Tournaments />
        </Suspense>
        <Suspense fallback={<SectionFallback id="betting-odds" />}>
          <BettingSection />
        </Suspense>
        <Suspense fallback={<SectionFallback id="stats" />}>
          <StatsSection />
        </Suspense>
        <Suspense fallback={<SectionFallback id="players" />}>
          <PlayerSection />
        </Suspense>
        <Suspense fallback={<SectionFallback id="playoffs" />}>
          <PlayoffBracket />
        </Suspense>
        <Suspense fallback={<SectionFallback id="international-tournaments" />}>
          <InternationalTournaments />
        </Suspense>
        <Suspense fallback={<SectionFallback id="standings" />}>
          <Standings />
        </Suspense>
        <Suspense fallback={<SectionFallback id="rulebook" />}>
          <Rulebook />
        </Suspense>
      </main>
      <Footer />
      <Suspense fallback={null}>
        <HockeyChatbot />
      </Suspense>
    </div>
  );
};

export default Index;
